<template>
  <section class="landing landingbb purchase-sale">
    <div class="overlay">
      <div class="container">
        <div class="landing-content subpage-heading-center">
          <span class="mini-title">{{ $t('motolabels.headingsale') }}</span>
          <span class="heading-title">{{ $t('motolabels.titlesale') }}</span>
          <hr>
          <span class="paragraph">{{ $t('motolabels.paragraphsale') }}</span>
        </div>
      </div>
    </div>
  </section>
  <form @submit.prevent="handleSubmit">
    <div class="market-form">
      <div class="container">
        <div class="form-grid">

                    <!-- From MFK -->
        <div class="input-container input-container-full">
            <label for="mfk">{{ $t('motolabels.mfk') }} * :</label>
            <select id="mfk" name="mfk" v-model="formData.mfk" @change="validateField('mfk')">
              <option :value="true">{{ $t('motolabels.yes') }}</option>
              <option :value="false">{{ $t('motolabels.no') }}</option>
            </select>

          </div>


          <!-- First Name -->
          <div class="input-container">
            <label for="fname">{{ $t('motolabels.fname') }} * :</label>
            <input type="text" id="fname" name="fname" v-model="formData.fname" @input="validateField('fname')">
            <p class="error-message" v-if="errors.fname">{{ errors.fname }}</p>
          </div>

          <!-- Last Name -->
          <div class="input-container">
            <label for="lname">{{ $t('motolabels.lname') }} * :</label>
            <input type="text" id="lname" name="lname" v-model="formData.lname" @input="validateField('lname')">
            <p class="error-message" v-if="errors.lname">{{ errors.lname }}</p>
          </div>

          <!-- Phone 1 -->
          <div class="input-container">
            <label for="phone1">{{ $t('motolabels.phone1') }} * :</label>
            <input type="text" id="phone1" name="phone1" v-model="formData.phone1" @input="validateField('phone1')">
            <p class="error-message" v-if="errors.phone1">{{ errors.phone1 }}</p>
          </div>

          <!-- Phone 2 -->
          <div class="input-container">
            <label for="phone2">{{ $t('motolabels.phone2') }}:</label>
            <input type="text" id="phone2" name="phone2" v-model="formData.phone2" @input="validateField('phone2')">
            <p class="error-message" v-if="errors.phone2">{{ errors.phone2 }}</p>
          </div>

          <!-- Email -->
          <div class="input-container">
            <label for="email">{{ $t('motolabels.email') }} * :</label>
            <input type="email" id="email" name="email" v-model="formData.email" @input="validateField('email')">
            <p class="error-message" v-if="errors.email">{{ errors.email }}</p>
          </div>

          <!-- Street / No. -->
          <div class="input-container">
            <label for="street">{{ $t('motolabels.street') }} * :</label>
            <input type="text" id="street" name="street" v-model="formData.street" @input="validateField('street')">
            <p class="error-message" v-if="errors.street">{{ errors.street }}</p>
          </div>

          <!-- ZIP / City -->
          <div class="input-container">
            <label for="zip">{{ $t('motolabels.zip') }} * :</label>
            <input type="text" id="zip" name="zip" v-model="formData.zip" @input="validateField('zip')">
            <p class="error-message" v-if="errors.zip">{{ errors.zip }}</p>
          </div>

          <!-- Brand -->
          <div class="input-container">
            <label for="brand">{{ $t('motolabels.brand') }} * :</label>
            <input type="text" id="brand" name="brand" v-model="formData.brand" @input="validateField('brand')">
            <p class="error-message" v-if="errors.brand">{{ errors.brand }}</p>
          </div>

          <!-- Model -->
          <div class="input-container">
            <label for="model">{{ $t('motolabels.model') }} * :</label>
            <input type="text" id="model" name="model" v-model="formData.model" @input="validateField('model')">
            <p class="error-message" v-if="errors.model">{{ errors.model }}</p>
          </div>

          <!-- Last Inspection -->
          <div class="input-container">
            <label for="inspection">{{ $t('motolabels.inspection') }} * :</label>
            <input type="date" id="inspection" name="inspection" v-model="formData.inspection"
              @input="validateField('inspection')">
            <p class="error-message" v-if="errors.inspection">{{ errors.inspection }}</p>
          </div>

          <!-- Mileage -->
          <div class="input-container">
            <label for="mileage">{{ $t('motolabels.mileage') }} * :</label>
            <input type="number" id="mileage" name="mileage" v-model="formData.mileage"
              @input="validateField('mileage')">
            <p class="error-message" v-if="errors.mileage">{{ errors.mileage }}</p>
          </div>

          <!-- CC -->
          <div class="input-container">
            <label for="cc">{{ $t('motolabels.cc') }} * :</label>
            <input type="number" id="cc" name="cc" v-model="formData.cc" @input="validateField('cc')">
            <p class="error-message" v-if="errors.cc">{{ errors.cc }}</p>
          </div>

          <!-- PS -->
          <div class="input-container">
            <label for="ps">{{ $t('motolabels.ps') }} * :</label>
            <input type="number" id="ps" name="ps" v-model="formData.ps" @input="validateField('ps')">
            <p class="error-message" v-if="errors.ps">{{ errors.ps }}</p>
          </div>

          <!-- Color -->
          <div class="input-container">
            <label for="color">{{ $t('motolabels.color') }} * :</label>
            <input type="text" id="color" name="color" v-model="formData.color" @input="validateField('color')">
            <p class="error-message" v-if="errors.color">{{ errors.color }}</p>
          </div>

          <!-- Year -->
          <div class="input-container">
            <label for="year">{{ $t('motolabels.year') }} * :</label>
            <input type="number" id="year" name="year" v-model="formData.year" @input="validateField('year')">
            <p class="error-message" v-if="errors.year">{{ errors.year }}</p>
          </div>

          <!-- Price Proposal -->
          <div class="input-container">
            <label for="price">{{ $t('motolabels.price') }} * :</label>
            <input type="text" id="price" name="price" v-model="formData.price" @input="validateField('price')">
            <p class="error-message" v-if="errors.price">{{ errors.price }}</p>
          </div>

          <!-- Extras -->
          <div class="input-container">
            <label>{{ $t('motolabels.extras') }}:</label>
            <div class="checkbox-group">
              <div class="property-items-column">
                <div class="property-item">
                  <input type="checkbox" id="chopper" name="extras" value="chopper" v-model="formData.extras"
                    :checked="formData.extras.includes('chopper')" @change="handleCheckboxChange($event, 'chopper')">
                  <label for="chopper">{{ $t('motolabels.chopper') }}</label>
                </div>
                <div class="property-item">
                  <input type="checkbox" id="enduro" name="extras" value="enduro" v-model="formData.extras"
                    :checked="formData.extras.includes('enduro')" @change="handleCheckboxChange($event, 'enduro')">
                  <label for="enduro">{{ $t('motolabels.enduro') }}</label>
                </div>
                <div class="property-item">
                  <input type="checkbox" id="gespanne" name="extras" value="gespanne" v-model="formData.extras"
                    :checked="formData.extras.includes('gespanne')" @change="handleCheckboxChange($event, 'gespanne')">
                  <label for="gespanne">{{ $t('motolabels.gespanne') }}</label>
                </div>
                <div class="property-item">
                  <input type="checkbox" id="oldtimer" name="extras" value="oldtimer" v-model="formData.extras"
                    :checked="formData.extras.includes('oldtimer')" @change="handleCheckboxChange($event, 'oldtimer')">
                  <label for="oldtimer">{{ $t('motolabels.oldtimer') }}</label>
                </div>
                <div class="property-item">
                  <input type="checkbox" id="strassenmaschine" name="extras" value="strassenmaschine"
                    v-model="formData.extras" :checked="formData.extras.includes('strassenmaschine')"
                    @change="handleCheckboxChange($event, 'strassenmaschine')">
                  <label for="strassenmaschine">{{ $t('motolabels.strassenmaschine') }}</label>
                </div>
                <div class="property-item">
                  <input type="checkbox" id="roller" name="extras" value="roller" v-model="formData.extras"
                    :checked="formData.extras.includes('roller')" @change="handleCheckboxChange($event, 'roller')">
                  <label for="roller">{{ $t('motolabels.roller') }}</label>
                </div>
              </div>
            </div>
          </div>


          <div class="input-container">
            <label for="photo">{{ $t('motolabels.photo') }}</label>

            <!-- Image List (Each Image in a Row) -->
            <div class="file-upload-list">
              <div v-for="(fileInput, index) in fileInputs" :key="index" class="file-upload-wrapper">

                <!-- Hidden file input -->
                <input type="file" :id="'photo-' + index" name="photo[]" accept="image/*" multiple
                  @change="handleFileUpload($event, index)" class="hidden-file-input" ref="fileInputRefs" />

                <!-- Image Box (80% width) -->
                <div class="image-box" @click="triggerFileInput(index)">
                  <span v-if="selectedFiles[index]?.length" class="file-name">
                    {{ selectedFiles[index][0].name }}
                  </span>
                  <span v-else class="plus-icon">+</span>
                </div>

                <!-- Remove Button (20% width, only if a file is uploaded) -->
                <div v-if="selectedFiles[index]?.length" class="remove-box">
                  <button type="button" class="remove-btn" @click="removeFileInput(index)">
                    ✖
                  </button>
                </div>

              </div>
            </div>
            <p class="error-message" v-if="errors.photo">{{ errors.photo }}</p>
          </div>

          <!-- Date -->
          <div class="input-container">
            <label for="date">{{ $t('motolabels.date') }} * :</label>
            <input type="date" id="date" name="date" v-model="formData.date" @input="validateField('date')">
            <p class="error-message" v-if="errors.date">{{ errors.date }}</p>
          </div>

          <!-- Signature -->
          <div class="input-container">
            <label for="signature">{{ $t('motolabels.signature') }} * :</label>
            <input type="text" id="signature" name="signature" v-model="formData.signature"
              @input="validateField('signature')">
            <p class="error-message" v-if="errors.signature">{{ errors.signature }}</p>
          </div>

          <!-- Remarks -->
          <div class="textarea-container">
            <label for="remarks">{{ $t('motolabels.remarks') }}:</label>
            <textarea id="remarks" name="remarks" v-model="formData.remarks"
              @input="validateField('remarks')"></textarea>
            <p class="error-message" v-if="errors.remarks">{{ errors.remarks }}</p>
          </div>

          <!-- Submit Button -->
          <button type="submit">{{ $t('autopurchaseform.labels.submit') }}</button>
        </div>
      </div>
    </div>
  </form>

</template>

<script>
import axios from "axios";
import API_BASE_URL from "@/config";

export default {
  name: "MotoPurchaseForm",
  data() {
    return {
      formData: {
        fname: "",
        lname: "",
        phone1: "",
        phone2: "",
        email: "",
        street: "",
        zip: "",
        brand: "",
        model: "",
        inspection: "",
        mfk: true,
        mileage: "",
        cc: "",
        ps: "",
        color: "",
        year: "",
        price: "",
        extras: [],
        photo: [],
        date: "",
        signature: "",
        remarks: ""
      },
      errors: {},
      fileInputs: [{}],
      selectedFiles: [],
      maxFields: 15,
    };
  },
  methods: {
    async handleFileUpload(event, index) {
      const files = Array.from(event.target.files);
      if (files.length === 0) return;

      console.log("📸 Files selected:", files.map(f => f.name));

      try {
        if (!this.formData.photo) {
          this.formData.photo = [];
        }

        const formData = new FormData();
        formData.append("field", "photo");
        formData.append("lang", this.$i18n.locale);

        files.forEach(file => formData.append("photo", file));

        const response = await axios.post(
          `${API_BASE_URL}/auto-purchase/validate-picture`,
          formData,
          { headers: { "Content-Type": "multipart/form-data" } }
        );

        if (response.data.success) {
          this.errors.photo = '';

          // Keep only the first file in the current input
          this.selectedFiles[index] = [files[0]];
          this.formData.photo[index] = [files[0]];

          console.log("✅ Successfully uploaded:", files.map(f => f.name));

          // Push remaining files to new inputs
          const remainingFiles = files.slice(1);
          remainingFiles.forEach((file) => {
            if (this.fileInputs.length < this.maxFields) {
              this.fileInputs.push({});
              this.selectedFiles.push([file]); // Assign each file to a new field
              this.formData.photo.push([file]);
            }
          });

          // Ensure there is always an empty field for adding new images
          if (this.fileInputs.length < this.maxFields && !this.selectedFiles.some(arr => arr.length === 0)) {
            this.fileInputs.push({});
            this.selectedFiles.push([]);
          }

          event.target.value = "";
        } else {
          console.error("❌ Backend Error:", response.data.errors);
          this.errors.photo = response.data.errors[0]?.msg || "Validation failed.";
          event.target.value = "";
        }
      } catch (error) {
        console.error("❌ Upload Error:", error);
        this.errors.photo = error.response?.data?.errors?.map(err => err.msg).join(", ") || "Unknown error occurred.";
        event.target.value = "";
      }
    },

    triggerFileInput(index) {
      if (this.$refs.fileInputRefs && this.$refs.fileInputRefs[index]) {
        this.$refs.fileInputRefs[index].click();
      }
    },

    removeFileInput(index) {
      if (this.fileInputs.length > 1) {
        this.fileInputs.splice(index, 1);
        this.selectedFiles.splice(index, 1);
        this.formData.photo.splice(index, 1);
      }

      // Ensure there's at least one empty "+" field at the end
      if (!this.selectedFiles.some(arr => arr.length === 0) && this.fileInputs.length < this.maxFields) {
        this.fileInputs.push({});
        this.selectedFiles.push([]);
      }
    },

    handleDrop(event, index) {
      event.preventDefault();
      const files = Array.from(event.dataTransfer.files);
      if (files.length > 0) {
        this.handleFileUpload({ target: { files } }, index);
      }
    },

    addFileInput() {
      this.fileInputs.push({});
      this.selectedFiles.push([]); // Maintain selectedFiles array consistency
      this.$nextTick(() => {
        this.$refs.fileInputRefs = this.$refs.fileInputRefs || [];
      });
    },

    async validateField(field) {
      console.log(`🔍 Validating field: ${field} with value:`, this.formData[field]);
      try {
        const response = await axios.post(`${API_BASE_URL}/moto-sale/validate`, {
          field,
          value: this.formData[field],
          lang: this.$i18n.locale
        });

        if (response.data.success) {
          this.errors[field] = '';
          return true;
        }
      } catch (error) {
        if (error.response?.data?.errors) {
          this.errors[field] = error.response.data.errors[0]?.msg || 'Validation error';
        } else {
          this.errors[field] = 'Unknown error occurred';
        }
        return false;
      }
    },

    handleCheckboxChange(event, value) {
      if (!Array.isArray(this.formData.extras)) {
        this.formData.extras = [];
      }
      if (event.target.checked) {
        if (!this.formData.extras.includes(value)) {
          this.formData.extras.push(value);
        }
      } else {
        this.formData.extras = this.formData.extras.filter(item => item !== value);
      }
    },

    async handleSubmit() {
    try {
        this.errors = {}; // Reset errors before validation

        // Validate all fields except 'photo' and 'mfk'
        const fieldsToValidate = Object.keys(this.formData).filter(
            key => key !== "photo" && key !== "mfk"
        );

        const validationResults = await Promise.all(
            fieldsToValidate
                .filter(field => field !== "extras") // Exclude "extras"
                .map(async field => {
                    const isValid = await this.validateField(field);
                    return { field, isValid };
                })
        );

        // Check if any field is invalid
        if (validationResults.some(result => !result.isValid)) {
            alert(this.$t("autopurchaseform.labels.formErrors"));
            return;
        }

        // Prepare form data for submission
        const form = new FormData();

        // Append validated form fields
        fieldsToValidate.forEach((key) => {
            if (key === "extras" && Array.isArray(this.formData.extras)) {
                this.formData.extras.forEach(item => form.append("extras[]", item));
            } else {
                if (this.formData[key]) {
                    form.append(key, this.formData[key]); // Avoid appending empty fields
                }
            }
        });

        // Append 'photo' separately (if any)
        if (this.formData.photo && Array.isArray(this.formData.photo)) {
            this.formData.photo
                .flat()
                .filter(file => file instanceof File) // Ensure only valid files are appended
                .forEach((file) => {
                    form.append("photo", file);
                });
        }

        // Log Form Data for Debugging
        console.log("📤 Sending FormData:");
        for (let pair of form.entries()) {
            console.log(`${pair[0]}:`, pair[1]);
        }

        // Send the form data
        const response = await axios.post(
            `${API_BASE_URL}/moto-sale/submit-moto`,
            form,
            {
                headers: {
                    "Content-Type": "multipart/form-data",
                    "Accept-Language": this.$i18n.locale,
                },
            }
        );

        // Reset photos after submission
        this.formData.photo = [];
        this.selectedFiles = [];
        this.fileInputs = [{}]; // Reset file inputs

        // Handle success
        if (response.status === 200) {
            const locale = this.$i18n.locale;
            sessionStorage.setItem("formSubmitted", "true");
            this.$router.push({ name: `SuccessPage${locale.toUpperCase()}` });
        }
    } catch (error) {
        console.error("🚨 Submission Error:", error);

        // Check if backend returned an error message
        if (error.response) {
            console.error("🔴 Server Response Data:", error.response.data);
            console.error("🔴 Status Code:", error.response.status);

            if (error.response.status === 500) {
                alert("🚨 Server error. Please try again later.");
            } else if (error.response.status === 400) {
                this.errors = {};
                error.response.data.errors.forEach(err => {
                    this.errors[err.field] = err.msg;
                    alert(err.msg);
                });
            } else {
                alert("Unexpected error occurred. Please check console logs.");
            }
        } else {
            alert("❌ Network Error: Unable to reach the server.");
        }
    }
}

  },
  mounted() {
    this.$refs.fileInputRefs = []; // Ensure refs are initialized
  }
};
</script>


<style scoped>
/* Hide the default file input */
.hidden-file-input {
  display: none;
}

/* File List: Display images in a column */
.file-upload-list {
  display: flex;
  flex-direction: column;
  gap: 10px;
}

/* Image Row */
.file-upload-wrapper {
  display: flex;
  width: 100%;
  align-items: center;
}

/* Image Box (80% width) */
.image-box {
  display: flex;
  align-items: center;
  justify-content: center;
  width: 80%;
  height: 50px;
  border: 2px solid #6dc6a4;
  border-radius: 5px;
  background-color: #f5f5f5;
  color: #6dc6a4;
  font-size: 16px;
  padding: 10px;
  position: relative;
  cursor: pointer;
}

/* Centered "+" icon */
.plus-icon {
  font-size: 24px;
  font-weight: bold;
  color: #6dc6a4;
  margin: auto;
}

/* File Name */
.file-name {
  flex: 1;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  padding-left: 10px;
}

/* Remove Button Box (20% width, aligned right) */
.remove-box {
  width: 20%;
  display: flex;
  align-items: center;
  justify-content: center;
}

/* Remove Button */
.remove-btn {
  background-color: transparent;
  border: none;
  color: #ff5252;
  font-size: 20px;
  cursor: pointer;
}

.remove-btn:hover {
  color: white;
  background-color: red;
}
</style>